module.exports = __webpack_public_path__ + "img/icon-message-enable.4659e713.svg";